import { useSelector } from 'react-redux'

import { selectCurrentEnterprise } from '@/store/features/user/userSlice'

export const hasDepartments = (enterprise: { team_count?: number } | null): boolean =>
  (enterprise?.team_count ?? 0) > 1

export const useHasDepartments = (): boolean => {
  const enterprise = useSelector(selectCurrentEnterprise)
  return hasDepartments(enterprise)
}
